import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Text } from '../ui/AppText';
import { useTheme } from '../../contexts/ThemeContext';

// Bloco pessoal do cabecalho da Home (lado direito, usuario logado):
// streak (dias seguidos) + XP. Dados vem de gamificationStats (useHomeStats),
// ja carregados na Home — sem query extra. Theme-aware como o resto do Header.
const formatNumber = (value) => {
  const n = typeof value === 'number' ? value : 0;
  return n.toLocaleString('pt-BR');
};

const HomeHeaderStats = memo(({ streak = 0, xp = 0, onPress }) => {
  const { isDarkMode } = useTheme();

  const pillBg = isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(91,143,249,0.12)';
  const valueColor = isDarkMode ? '#FFFFFF' : '#1F2937';
  const labelColor = isDarkMode ? 'rgba(255,255,255,0.7)' : '#6B7280';

  const content = (
    <View style={styles.row}>
      <View style={[styles.pill, { backgroundColor: pillBg }]}>
        <Text style={styles.icon}>🔥</Text>
        <Text style={[styles.value, { color: valueColor }]}>{formatNumber(streak)}</Text>
        <Text style={[styles.label, { color: labelColor }]}>dias</Text>
      </View>
      <View style={[styles.pill, { backgroundColor: pillBg }]}>
        <Text style={styles.icon}>⭐</Text>
        <Text style={[styles.value, { color: valueColor }]}>{formatNumber(xp)}</Text>
        <Text style={[styles.label, { color: labelColor }]}>XP</Text>
      </View>
    </View>
  );

  if (onPress) {
    return (
      <TouchableOpacity onPress={onPress} activeOpacity={0.8} accessibilityRole="button">
        {content}
      </TouchableOpacity>
    );
  }
  return content;
});

HomeHeaderStats.displayName = 'HomeHeaderStats';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 10,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  icon: {
    fontSize: 12,
    marginRight: 3,
  },
  value: {
    fontSize: 13,
    fontWeight: '700',
    marginRight: 3,
  },
  label: {
    fontSize: 10,
    fontWeight: '500',
  },
});

export default HomeHeaderStats;
